<script>
export default {
    data() {
        return {
            acLink: "1",
        };
    },
    watch: {
        $route(to, form) {
            this.getLevel(to);
        },
    },
    created() {
        let route = this.$route;
        this.getLevel(route);
    },
    methods: {
        getLevel(route) {
            let level = route.meta ? route.meta.level : "1";
            this.acLink = level.split("-")[0];
        },
    },
    render(h) {
        return (
            <div class="aside-container">
                <router-link
                    tag="a"
                    to="/"
                    class={["aside-links", this.acLink == "1" ? "ac" : ""]}
                >
                    <img
                        src={
                            this.acLink == "1"
                                ? require("@/assets/images/Vector.png")
                                : require("@/assets/images/Vector-h.png")
                        }
                        alt=""
                    />
                    <span>Homepage</span>
                </router-link>
                <router-link
                    tag="a"
                    to="/IndutryNews/list"
                    class={["aside-links", this.acLink == "2" ? "ac" : ""]}
                >
                    <img
                        src={
                            this.acLink == "2"
                                ? require("@/assets/images/Vector-1.png")
                                : require("@/assets/images/Vector-1-h.png")
                        }
                        alt=""
                    />
                    <span>Industry News</span>
                </router-link>
                <router-link
                    tag="a"
                    to="/Production"
                    class={["aside-links", this.acLink == "3" ? "ac" : ""]}
                >
                    <img
                        src={
                            this.acLink == "3"
                                ? require("@/assets/images/Vector-2.png")
                                : require("@/assets/images/Vector-2-h.png")
                        }
                        alt=""
                    />
                    <span>Production/Sales</span>
                </router-link>
                <router-link
                    tag="a"
                    to="/ByModels"
                    class={["aside-links", this.acLink == "4" ? "ac" : ""]}
                >
                    <img
                        src={
                            this.acLink == "4"
                                ? require("@/assets/images/Vector-3.png")
                                : require("@/assets/images/Vector-3-h.png")
                        }
                        alt=""
                    />
                    <span>By Models</span>
                </router-link>
                 <router-link
                    tag="a"
                    to="/data/dataTable"
                    class={["aside-links", this.acLink == "5" ? "ac" : ""]}
                >
                    <img
                        src={
                            this.acLink == "5"
                                ? require("@/assets/images/Vector-3.png")
                                : require("@/assets/images/Vector-3-h.png")
                        }
                        alt=""
                    />
                    <span>Data Overview</span>
                </router-link>
            </div>
        );
    },
};
</script>
<style lang="less" scoped>
.aside-container {
    width: 100%;
}
.aside-links {
    display: flex;
    align-items: center;
    padding: 13px 17px;
    line-height: 22px;
    color: #333;
    margin-bottom: 8px;
    text-decoration: none;
    &.ac {
        color: #0d57bc;
        font-weight: bold;
        background: rgba(13, 87, 188, 0.08);
    }
    img {
        width: 14px;
    }
    span {
        padding-left: 9px;
    }
}
</style>